<template>
  <modal title="mTAN bestätigen">
    <mtan-input
      v-model="mtan"
      :mtansend="mtansend"
      class="ion-margin-top"
    >
    </mtan-input>
    <template v-slot:footer>
      <ion-button
        expand="block"
        @click="$parent[submitFunctionName](true, mtan)"
        :disabled="mtan === ''"
      >Bestätigen</ion-button>
    </template>
  </modal>
</template>

<script>
import Modal from "./Modal";
import MtanInput from "./MtanInput";

export default {
  components: {
    Modal,
    MtanInput
  },
  props: {
    mtansend: {
      type: String,
      required: true
    },
    submitFunctionName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mtan: ""
    };
  }
};
</script>

<style>
</style>